import { Box } from '@looker/components';
import { type FC, useMemo } from 'react';
import type { ICustomFilter } from '../../../../../../helpers/helpers';
import { useFilters } from '../../../../../../hooks/useFilters';
import type { Filter } from '../../../../../../stores/filters';
import AdvancedFilters from '../../AdvancedFilters';

export const CareTeam: FC<ICustomFilter> = () => {
  const filterName = 'extend_with_care_team';
  const { filters } = useFilters();
  const filtersList = useMemo(() => (filters ? (Object.values(filters) as Array<Filter>) : []), [filters]);

  const careTeamFilter = filtersList.find((filter) => filter.filterName === filterName);

  return (
    <Box>
      {careTeamFilter?.expression === 'Yes' && (
        <AdvancedFilters context={'extend_with_care_team'} displayHintText={false} />
      )}
    </Box>
  );
};
